import styled from 'styled-components'
import { Layout } from 'antd'
import { colors } from 'Common/constants'

export const HeaderBar = styled.div`
  height: 16px;
  background-color: ${colors.main};
`
export const StyledHeader = styled(Layout.Header)`
  background-color: ${colors.white};
  border: 1px solid ${colors.grey2};
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08);
  height: 72px;
  display: grid;
  grid-gap: 50px;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  padding: 0 16px;
  z-index: 999;
`
export const AppLogo = styled.img`
  @media (max-width: 767px) {
    display: none;
  }
`
